import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";

// import DataGrid from "../../components/DataGrid";
import HttpServices from "../../utils/Http.services";
// import AdminModule from "../../components/boxes/AdminModule";
// import { adminPages } from "../../variables/adminPages";
import { checkPermission, checkTranslation, translate } from "../../utils/useful";
import HomeDashboard from "../../components/boxes/HomeDashboard";
import AdminReport from "./AdminReport";


class HomeDashboards extends React.Component {


    state = {
        modules: [],
        branches: [],
        dashboards: [
            { key: 'adminPages', name: '{{lang}}Documents Records' },
            // { key: 'energyPages', name: '{{lang}}Energy' },
            // { key: 'carbonPages', name: '{{lang}}Carbon' },
        ],
    }


    componentDidMount() {
        this.getApplets()
    }


    getApplets = (prop, index, reference) => {

        let body = {}
        HttpServices.request('getMyApplets', body, (fetchResult, fetchError) => {
            // console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}Failed to fetch'), description: checkTranslation(fetchError.message) })
                return
            }
            // let branches = this.state.branches
            let branches = [...fetchResult.info]

            this.setState({ branches })
            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            // this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Email Sent'), description: checkTranslation('{{lang}}Email sent successfully') })
        })

    }


    render() {
        // console.log('bef modules', this.props.modules)
        let modules = this.props.modules
        let newModule = []
        // console.log('modulesfirst',modules)
        // if (!this.props.home) {
        modules.map((item) => {
            if (!item.hidePage && checkPermission('admin.' + item.key) || item.defaultAccess) {
                newModule.push(item)
            }
        })
        // modules = modules.filter(m => { return m.hidePage != true })
        // }
        // console.log('after modules', modules)
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTranslation(this.props.title), button: {} }}
                title={checkTranslation(this.props.title)}
                description={this.props.description}
                className=""
            >

                <div className="row m-0">

                    <div className="col-12 px-4 container">

                        <div className="  mb-4 px-4 mt-4 ">
                            <p className="text-ultra-big " style={{ fontWeight: '500', color: '#222' }}>{checkTranslation(this.props.title)}</p>
                            <p className="text-normal mt-1" style={{ color: '#222', fontWeight: 500 }}>{checkTranslation(this.props.description)}</p>
                        </div>
                        {/* <div className="mb-2">
                            <p className="text-semibold">{translate("دسترسی سریع")}</p>
                        </div> */}
                        <div className="w-100 row m-0 mt-5" style={{}}>
                            {/* {this.props.admin && (

                                <AdminReport />
                            )} */}

                            {Array.isArray(this.state.branches) && this.state.branches.map((branch, index) => {

                                let boxData = { title: branch.name, description: 'دسترسی به شعبه', pageHome: 'branch', key: branch._id, image: '/images/kheiry/branch.png', page: 'branch', }
                                return (
                                    // <button onClick={() => this.props.handlePlatformWidgets(prop)} className='flexcc py-2 px-3 mrd-3' style={{ background: this.props.activeWidgets == prop.key ? "#184d94" : "#184d94cc", borderRadius: 8 }}>
                                    //     <p style={{ color: "white", fontSize: 14 }} className='cursor-pointer' >{checkTranslation(prop.name)}</p>
                                    // </button>

                                    <div className="w-100 col-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{}}>
                                        <div className="w-100" style={{ background: '#fff', borderRadius: 8 }}>
                                            <HomeDashboard data={boxData} />
                                        </div>
                                    </div>
                                )
                            })}

                            {newModule.map((prop, index) => {
                                return (
                                    <div className="w-100 col-12 col-sm-6 col-md-4 col-lg-3 mb-3" style={{}}>
                                        <div className="w-100" style={{ background: '#fff', borderRadius: 8 }}>
                                            <HomeDashboard data={prop} />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {/* <div className="w-100  my-5 flexc" style={{}}>
                            {Array.isArray(this.state.branches) && this.state.branches.map((prop, index) => {
                                return (
                                    <button onClick={() => this.props.handlePlatformWidgets(prop)} className='flexcc py-2 px-3 mrd-3' style={{ background: this.props.activeWidgets == prop.key ? "#184d94" : "#184d94cc", borderRadius: 8 }}>
                                        <p style={{ color: "white", fontSize: 14 }} className='cursor-pointer' >{checkTranslation(prop.name)}</p>
                                    </button>
                                )
                            })}
                        </div> */}
                        {/* <DataGrid isLoading={this.state.isLoading} data={newModule} component={HomeDashboard} col="col-12 col-sm-6 col-md-6 col-lg-3 p-0 p-md-3" settings={{ route: this.props.route }} /> */}
                    </div>
                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeDashboards);
